import { Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { ConfigStore } from "../../store/modules/config";
import { PersonStore } from "../../store/modules/person";
import { container } from "@/inversify.config";
import IAlertService from "../../services/alert/IAlertService";
import { DiTokens } from "../../services/diTokens";
import i18n from "@/i18n";
import Vue from "vue";

/**
 *  Класс для компоненты окна подтверждения.
 */
export class VerifyBoxVue extends Vue {

  /** Значение кода из вне */
  @Prop() value!: string;

  /** Правила проверки кода */
  @Prop() codeRules!: Array<any>;

  /** Длина таймера до повторной отправки */
  @Prop() codeTimerValue!: number;

  /** Функция для повторной отправки */
  @Prop() reCreate!: Function;

  /**Признак отключения повтора кода */
  @Prop() disableRepeat!: boolean;

  /**Явное задание кода подтверждения (в секундах) */
  @Prop() verificationCodeLifeTime!: number;

  /** Значение таймера на дисплее */
  veriCodetimerVal: number = 0;

  /** Хранилище setTimeout для таймера на дисплее */
  veriCodetimer: any = null;

  /** Хранилище setTimeout для таймеров на повторнуюю отправку и блокировку поля */
  codeTimers: Array<any> = [];

  /** Значение поля внутри компоненты */
  modelValue: string = "";

  /** Разрешено ли изменение поля */
  isCodeAvailible: boolean = true;

  /** Показывать ли кнопку Отправить повторно */
  isCodeTimerShow: boolean = false;

  /** Признак загрузки */
  loading: boolean = false;

  defaultCodeTimerValue: number = 30000;

  /** Отслеживаем изменение внешнего v-model из вне */
  @Watch("value", { immediate: true })
  valueChanged() {
    this.modelValue = this.value;
  }

  /** Отслеживаем изменение внутреннего v-model */
  @Watch("modelValue", { immediate: true })
  modelChanged() {
    this.$emit("input", this.modelValue);
  }

  /** Отслеживаем значение таймера на дисплее, при нуле заканчиваем таймер */
  @Watch("veriCodetimerVal", { immediate: true })
  timerChanged(val: any) {
    if (val === 0) clearTimeout(this.veriCodetimer);
  }

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Хранилище данных пользователя
 * @returns {PersonStore}
 */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  /**
 * Информация о пользователе
 * @returns {PersonStore}
 */
  get personInfo(): any {
    return this.personStore.personInfo;
  }

  /**
 * Сервис уведомлений
 * @returns {IAlertService}
 */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  /**
 * Признак повторного запроса
 * @returns {boolean}
 */
  get enableCodeRepeat(): boolean {
    return !this.disableRepeat;
  }

  /**
 * Код подтверждения в секундах
 * @returns {number} - жизнь кода в секундах
 */
  get getCodeLifeTime(): number {
    const res = (this.verificationCodeLifeTime ||
        this.configStore.apiData.VerificationCodeTimeLife);
    return res ? (res * 60) : 60;
  }

  /**
 * Номер телефона пользователя
 * @returns {string} - Номер телефона пользователя
 */
  get getUserNumber(): string {
    if (this.personInfo && this.personInfo.Data.MobileTel)
      return `${i18n.t(
        "main.settings.sended"
      )}: ${this.$options.filters.phoneNumber(
        this.personInfo.Data.MobileTel
      )}`;
    return "";    
  }

  /**
 * Текст для таймера на дисплее
 * @returns {string} - Текст для таймера на дисплее
 */
  get getTimerText(): string {
    const resTime =
      this.veriCodetimerVal >= 10
        ? this.veriCodetimerVal
        : "0" + this.veriCodetimerVal;
    return i18n
      .t("main.operation.form.repeatCodeTimerText", {
        timer: resTime,
        seconds: this.sklonenie(this.veriCodetimerVal, [
          "секунду",
          "секунды",
          "секунд"
        ])
      })
      .toString();
  }

  /** Определяем склонение слова в зависимости от значения таймера */
  /** 
      @param number число для определения склонения
      @param txt массив склонений 
    */
  sklonenie(number: number, txt: Array<any>) {
    const cases = [2, 0, 1, 1, 1, 2];
    return txt[
      number % 100 > 4 && number % 100 < 20
        ? 2
        : cases[number % 10 < 5 ? number % 10 : 5]
    ];
  }

  /** Чистим все существующие таймеры */
  clearTimers() {
    if (this.codeTimers.length > 0) {
      this.codeTimers.map(val => clearTimeout(val));
      this.codeTimers = [];
    }
  }

  /** Запускаем таймеры, и обновляем все значения в изначальное состояние */
  initTimers() {
    if (this.codeTimerValue)
      this.defaultCodeTimerValue = this.codeTimerValue;
    this.modelValue = "";
    this.isCodeTimerShow = false;
    this.isCodeAvailible = true;
    this.codeTimers.push(
      setTimeout(() => {
        this.isCodeTimerShow = true;
      }, this.defaultCodeTimerValue)
    );
    this.codeTimers.push(
      setTimeout(() => {
        this.isCodeAvailible = false;
        this.modelValue = this.$i18n
          .t("main.operation.form.repeatCodeBlocked")
          .toString();
        //this.$refs.verifyInput.resetValidation();
      }, this.getCodeLifeTime * 1000)
    );
  }

  /** Повторная отправка кода */
  async repeatVerifyCode() {
    try {
      this.loading = true;
      await this.reCreate();
      this.loading = false;
      this.clearTimers();
      this.initTimers();
      //this.$store.dispatch('reCreateVerificationCode');
      this.getTimerValue();
      this.alertService.success(
        i18n.t("main.operation.form.repeatCodeSuccess").toString()
      );
    } catch (e) {
      if (e.message === "Действует двухфакторная авторизация!") {
        this.alertService.success(
          i18n.t("main.operation.form.repeatCodeSuccess").toString()
        );
        this.clearTimers();
        this.initTimers();
        //this.$store.dispatch('reCreateVerificationCode');
        this.getTimerValue();
      } else {
        this.alertService.error(i18n.t("common.errors.apiError").toString());
      }
    }
  }

  /** Отоброжание таймера на дисплее */
  getTimerValue() {
    this.veriCodetimerVal = this.defaultCodeTimerValue / 1000;
    this.veriCodetimer = setInterval(() => {
      this.veriCodetimerVal--;
    }, 1000);
  }
}
